module.exports = "<a (click)=\"logout()\"> <i class=\"icon-logout\"></i> Logout </a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/logout/logout.component.html
// module id = 639
// module chunks = 0